export default __webpack_public_path__ + "static/image01-bed542ac50426cf053ff4fb0e273b0fa.webp";